import { useCallback } from 'react';
import { styles } from 'flow-builder/renderers/node/nodeStyles';
import { getIsInBounds } from 'flow-builder/renderers/node/nodeUtils';
import { getIsNodeInTreeForId } from 'flow-builder/utils/node/getNodeTree/getNodeTree';
import { getOrphans } from 'flow-builder/utils/node/getOrphans/getOrphans';
export function useActionNodeMove({ state, }) {
    const { nodeState: { relations }, attachState, setAttachState, } = state;
    const onActionNodeMove = useCallback((actionNode) => {
        const ref = actionNode.ref;
        const { node: { id: actionNodeId }, } = actionNode.props;
        const { hoveredNodeId } = attachState;
        const targetPageX = ref.position.x + styles.base.width / 2;
        const targetPageY = ref.position.y;
        const orphans = getOrphans(relations);
        const newHoveredNode = orphans.find(({ id, height, pageX, pageY }) => {
            const bounds = {
                x: [pageX, pageX + styles.base.width],
                y: [pageY, pageY + height],
            };
            return (getIsInBounds(targetPageX, targetPageY, bounds) &&
                !getIsNodeInTreeForId(id, actionNodeId, relations));
        });
        if (newHoveredNode && hoveredNodeId !== newHoveredNode.id) {
            setAttachState({
                actionNodeId,
                hoveredNodeId: newHoveredNode.id,
                isDragging: true,
            });
            return;
        }
        if (hoveredNodeId && !newHoveredNode) {
            setAttachState({
                actionNodeId,
                hoveredNodeId: null,
                isDragging: true,
            });
            return;
        }
    }, [relations, attachState, setAttachState]);
    return onActionNodeMove;
}
